module.exports = __webpack_public_path__ + "img/contact.d8f2f1da.jpg";